import type { IconNode } from '../types';

/**
 * @name shorts-boxer
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNyAxNS44IDkgMjBINGEyIDIgMCAwIDEtMi0yVjVjMC0uNi40LTEgMS0xaDE4Yy42IDAgMSAuNCAxIDF2MTNhMiAyIDAgMCAxLTIgMmgtNWwtMS43LTQuMiIgLz4KICA8cGF0aCBkPSJNMiA4aDIwIiAvPgogIDxwYXRoIGQ9Ik0xNiA4djRhNCA0IDAgMCAxLTggMFY4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shorts-boxer
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shortsBoxer: IconNode = [
  [
    'path',
    {
      d: 'M10.7 15.8 9 20H4a2 2 0 0 1-2-2V5c0-.6.4-1 1-1h18c.6 0 1 .4 1 1v13a2 2 0 0 1-2 2h-5l-1.7-4.2',
      key: '1maj6a',
    },
  ],
  ['path', { d: 'M2 8h20', key: 'd11cs7' }],
  ['path', { d: 'M16 8v4a4 4 0 0 1-8 0V8', key: 'm2e4c1' }],
];

export default shortsBoxer;
